const DuplicateMaterial = (props: any) => {
  const color = props.color || "var(--theme-primary-color, #2E3092)";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 10.05V12.3C12.75 15.3 11.55 16.5 8.55 16.5H5.7C2.7 16.5 1.5 15.3 1.5 12.3V9.45005C1.5 6.45005 2.7 5.25005 5.7 5.25005H7.95"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.7492 10.05H10.3492C8.54922 10.05 7.94922 9.45005 7.94922 7.65005V5.25005L12.7492 10.05Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.69922 1.50005H11.6992"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 3.75005C5.25 2.50505 6.255 1.50005 7.5 1.50005H9.465"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5001 6.00005V10.6425C16.5001 11.805 15.5551 12.75 14.3926 12.75"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.5 6.00005H14.25C12.5625 6.00005 12 5.43755 12 3.75005V1.50005L16.5 6.00005Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export { DuplicateMaterial };
